export default {
  title: 'Points & Discounts',
  store_credit: 'Store credit',
  points_balance: 'Points balance',
};
